/**
 * @file Cascader 级联选择器
 */
import Cascader from 'antd/es/cascader';
export { Cascader };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ2FzY2FkZXIvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxRQUEyQixNQUFNLGtCQUFrQixDQUFBO0FBRTFELE9BQU8sRUFBRSxRQUFRLEVBQUUsQ0FBQSJ9